import { render, staticRenderFns } from "./J-1-2b__HR_Resume-Edit.vue?vue&type=template&id=b9142948&"
import script from "./J-1-2b__HR_Resume-Edit.vue?vue&type=script&lang=js&"
export * from "./J-1-2b__HR_Resume-Edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VSpacer})
